import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { EmailTemplate, emailTemplateSchema } from "./email-template";

export enum SavedEmailTemplateSource {
  FORWARDED = "forwarded",
  UPLOADED = "uploaded",
  SAVED = "saved",
}

export const savedEmailTemplateSchema = z.object({
  _id: zExt.objectId(),
  template: emailTemplateSchema as z.ZodType<EmailTemplate>,
  templateName: z.string(),
  team: zExt.objectId(),
  source: createEnum(SavedEmailTemplateSource).optional(),
  isGenerating: z.boolean().optional(),
  lastUsed: z.date().nullish(),
  createdAt: z.date().nullish(),
  updatedAt: z.date().nullish(),
});

export type SavedEmailTemplate = z.infer<typeof savedEmailTemplateSchema>;
